import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import Text from 'components/elements/text';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function CruisePurchaseAddOnsTable({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.cruisePurchases.${parentIndex}.cruisePurchaseAddOns`;
  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  if (!(value[name] || []).length) {
    return null;
  }

  return (
    <>
      <Separator gap={24} />
      <Text variant="ParagraphSmall">{t('ticketOrders:add_ons')}</Text>
      <div style={{ width: '100%' }}>
        <TableEditableComponent
          columns={columns}
          data={value[name]}
          dispatch={() => {}}
          disabled
          name={name}
        />
      </div>
    </>
  );
}
